var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276,
    height: 51.756,
    viewBox: "0 0 276 51.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prisma-logo",
    transform: "translate(2.876 2.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69078",
    "data-name": "Path 69078",
    d: "M726.553,140.1h-3.211V121.411h8.134c2.922,0,4.343,1.29,4.343,3.948v4.369c0,2.632-1.421,3.948-4.343,3.948h-4.922Zm0-9.45h4.475c1.053,0,1.553-.5,1.553-1.579v-3.053c0-1.106-.5-1.579-1.553-1.579h-4.475Z",
    transform: "translate(-642.87 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69079",
    "data-name": "Path 69079",
    d: "M866.152,121.411h8.423c2.711,0,4,1.185,4,3.554v5.212c0,2.158-1.053,3.317-3.264,3.527l4.448,6.4h-3.711l-4.37-6.37h-2.316v6.37h-3.211Zm3.211,9.265h4.4c1.079,0,1.579-.474,1.579-1.606v-3c0-1.132-.5-1.632-1.579-1.632h-4.4Z",
    transform: "translate(-769.623 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 3.211,
    height: 18.689,
    transform: "translate(112.954 12.977)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69080",
    "data-name": "Path 69080",
    d: "M1077.78,131.308c-2.632-1.211-3.474-1.816-3.474-4.185v-2.4c0-2.237,1.185-3.317,3.685-3.317h4.606c2.527,0,3.738,1.079,3.738,3.317v2.185h-3.211v-1.105a1.193,1.193,0,0,0-1.369-1.369h-2.869c-.974,0-1.369.395-1.369,1.369v.711c0,.921.316,1.158,1.185,1.553l4.422,1.948c2.369,1.079,3.475,1.632,3.475,3.553v3.238c0,2.185-1.185,3.29-3.659,3.29h-5.185c-2.527,0-3.712-1.105-3.712-3.29v-2.474h3.211v1.395a1.167,1.167,0,0,0,1.343,1.343h3.448a1.167,1.167,0,0,0,1.342-1.343V134.7c0-.79-.395-1.106-1.211-1.448Z",
    transform: "translate(-954.139 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69081",
    "data-name": "Path 69081",
    d: "M1219.428,140.1V121.411h3.29l4.4,8.923,4.422-8.923h3.29V140.1H1231.8V127.465l-3.132,6.344h-3.106l-3.132-6.37V140.1Z",
    transform: "translate(-1083.178 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69082",
    "data-name": "Path 69082",
    d: "M1390.752,121.411l6.027,18.689h-3.4l-1-3.317h-6.528l-1.026,3.317h-3.4l6.054-18.689Zm-3.975,12.345h4.685l-2.316-7.686Z",
    transform: "translate(-1226.97 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69083",
    "data-name": "Path 69083",
    d: "M1586.4,121.411l4.5,18.689h-.869l-1.027-4.37h-6.238l-1.027,4.37h-.842l4.5-18.689Zm-3.448,13.556h5.87l-2.922-12.608Z",
    transform: "translate(-1404.007 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69084",
    "data-name": "Path 69084",
    d: "M1699.359,140.1V121.411h.816l6.791,14.9c.448.974.658,1.606.921,2.29V121.411h.842V140.1h-.842l-6.475-14.319c-.579-1.211-.869-2.053-1.237-3V140.1Z",
    transform: "translate(-1509.149 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69085",
    "data-name": "Path 69085",
    d: "M1817.7,121.411l4.5,18.689h-.868l-1.026-4.37h-6.239l-1.026,4.37h-.842l4.5-18.689Zm-3.448,13.556h5.87l-2.922-12.608Z",
    transform: "translate(-1609.305 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69086",
    "data-name": "Path 69086",
    d: "M1931.479,139.336h6.791l-.105.763h-7.5V121.411h.816Z",
    transform: "translate(-1714.446 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69087",
    "data-name": "Path 69087",
    d: "M2001.079,140.1V132.15l-4.4-10.739h.9l3.448,8.66a4.987,4.987,0,0,1,.474,1.421,6.516,6.516,0,0,1,.448-1.4l3.448-8.686h.869l-4.37,10.713V140.1Z",
    transform: "translate(-1773.044 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69088",
    "data-name": "Path 69088",
    d: "M2104.844,122.174V140.1h-.816V122.174h-3.869v-.763h8.529v.763Z",
    transform: "translate(-1864.885 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 0.816,
    height: 18.689,
    transform: "translate(246.855 12.977)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69089",
    "data-name": "Path 69089",
    d: "M2254.072,139.336c1.474,0,1.948-.921,1.948-2.816v-2h.842v2c0,2.4-.684,3.58-2.764,3.58h-3.685c-2.105,0-2.764-1.184-2.764-3.58V124.991c0-2.4.658-3.58,2.764-3.58h3.685c2.08,0,2.764,1.184,2.764,3.58v1.948h-.842v-1.948c0-1.9-.474-2.816-1.948-2.816h-3.632c-1.448,0-1.975.921-1.975,2.816V136.52c0,1.9.527,2.816,1.975,2.816Z",
    transform: "translate(-1995.793 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69090",
    "data-name": "Path 69090",
    d: "M2360.7,129.6a3,3,0,0,1-1.869-3.185v-1.606c0-2.4.842-3.4,2.632-3.4h2.948c1.9,0,2.79.974,2.79,3.4v2.106h-.816v-2.027c0-1.9-.658-2.711-2-2.711h-2.738c-1.474,0-2,.711-2,2.816v1.369a2.26,2.26,0,0,0,1.342,2.422l4.527,2.4c1.448.79,1.9,1.448,1.9,3.317v2.316c0,2.185-.815,3.29-2.527,3.29h-3.553c-1.922,0-2.711-1.106-2.711-3.29v-2.29h.816V136.7c0,1.843.606,2.632,1.922,2.632h3.316c1.343,0,1.922-.79,1.922-2.632V134.6c0-1.5-.263-2-1.422-2.632Z",
    transform: "translate(-2094.285 -108.434)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69093",
    "data-name": "Path 69093",
    d: "M4.347,47.359-3.94-.145l3.11-.543,8.288,47.5Z",
    transform: "translate(33.83 0.736)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69091",
    "data-name": "Path 69091",
    d: "M42.811,51.756l-.9-.209L0,42.531,34,0,76.753,34.572ZM5.651,40.518,42.4,48.425,70.975,33.959,34.481,4.451Z",
    transform: "translate(-2.876 -2.266)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69092",
    "data-name": "Path 69092",
    d: "M7.336,235.6l-.612-1.265,31.627-15.291,39.334,8.041-.281,1.377-38.869-7.946Z",
    transform: "translate(-7.081 -195.708)",
    fill: "#051ee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M.405,23.785H-1V0H.405Z",
    transform: "translate(31.66 0.287)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52d33a0030ade8b24e76015b9361d960.svg";
export { ForwardRef as ReactComponent };